export const eventsData = [
  {
    id: "gramayana",
    title: "Residential Summer Camp – Gramayana Edition 2026",
    subtitle: "Warriors of Nature. Keepers of Tradition.",
    ageGroup: "9–15 Years (Boys & Girls)",
    venue: "Shivalingapuram, Kadthal Village (30 Acres Campus)",
    dates: "May 13th – May 20th, 2026",
    fee: "₹9,500 Per Child (All Inclusive)",
    timings: "7-Day Fully Residential Camp",
    image: "./images/RESIDENCIAL-SUMMERCAMP01.JPEG",
    aboutProgram: "Gramayana Residential Summer Camp 2026 is a 7-day immersive rural learning experience blending ancient Indian traditions, martial arts, farming, meditation, village life, cultural arts, and survival cooking. Children disconnect from screens and reconnect with discipline, nature, and values for life.",
    trainingModel: {
      title: "Traditional Immersion Model",
      steps: [
        "Wake Up with Nature – Sunrise rituals and meditation",
        "Discipline Through Tradition – Martial arts and physically engaging games",
        "Rooted Learning – Hands-on farming and village life experience",
        "Creative Expression – Traditional folk arts and storytelling",
        "Survival Skills – Firewood cooking and foraging"
      ]
    },
    activities: {
      highschool: [
        {
          title: "Ancient Indian Games & Martial Traditions",
          desc: "Archery Training, Gada-Mazze Practice, Kalari Basics, Kushti demos, Tyre races, Rope climbing, Bamboo maze."
        },
        {
          title: "Mind & Spirit",
          desc: "Daily Pyramid Meditation, Group Journaling, Fire Ritual, Astro Night."
        },
        {
          title: "Animal Husbandry & Farming",
          desc: "Milking cows, Feeding calves, Egg collection, Organic farming, Cleaning sheds."
        },
        {
          title: "Traditional Arts",
          desc: "Pottery, Kolam (Rangoli), Folk Songs & Dance (Kolattam, Lambadi)."
        },
        {
          title: "Survival Cooking",
          desc: "Firewood cooking, Mud stove chapatis, Pongal, Bajra roti, Bamboo rice, Foraging."
        }
      ]
    },
    dailySchedule: {
      days: "7-Day Fully Residential Camp (May 13 - 20)",
      includes: [
        "Morning Yoga & Meditation",
        "Skill-based Traditional Training",
        "Organic Farm Meals",
        "Evening Folk Art & Cultural Gathers",
        "Stargazing & Camping Rituals"
      ]
    },
    specialHighlights: [
      "30 Acres Open Campus Experience 🌳",
      "Traditional Martial Arts Training ⚔️",
      "Organic Farming & Animal Care 🐄",
      "Survival Cooking on Mud Stoves 🥘",
      "Digital Detox & Values for Life 📵"
    ],
    whyChoose: [
      "Authentic Rural Learning Environment",
      "Holistic Character Building",
      "Safe & Monitored Residential Dorms",
      "100% Organic Meals",
      "Professional Traditional Trainers"
    ],
    learningOutcomes: [
      "Stronger physical discipline & endurance",
      "Deep connection with Indian roots & nature",
      "Improved focus through meditation",
      "Basic survival & self-sufficiency skills",
      "Lasting friendships & teamwork"
    ],
    brochures: ["./images/RESIDENCIAL-SUMMERCAMP01.JPEG", "./images/RESIDENCIAL-SUMMERCAMP02.JPEG"],
    contact: "98498 56143"
  },

  {
    id: "tech-gen-iris",
    title: "Tech Generation Summer Camp 2026 (IRIS Florets)",
    subtitle: "STEM • Life Skills • Adventure • Arts",
    ageGroup: "4–15 Years",
    venue: "IRIS Florets World School, Bongloor, Hyderabad",
    dates: "30 April – 30 May 2026",
    fee: "₹4,499",
    timings: "9:00 AM – 3:00 PM",
    image: "./images/IRIS01.jpeg",
    aboutProgram: "Tech Generation Summer Camp is a unique skill-based learning experience designed to help children explore technology, creativity, fitness, and life skills — all in one place.",
    trainingModel: {
      title: "Hybrid Experiential Learning Model",
      steps: [
        "Learn → Practice → Perform: Students first understand concepts, then practice hands-on, and finally present what they've learned.",
        "Multi-Skill Rotation System: Balanced development between Technology, Arts, and Physical Activities.",
        "Level-Based Training: Separate fun-based learning for primary and skill-focused training for high school.",
        "Weekly Progress Tracking: Continuous observation and confidence-building activities.",
        "Final Showcase & Recognition: Participation in DJ performances, talent shows, and film screenings."
      ]
    },
    activities: {
      primary: [
        {
          title: "Junior AI Lab",
          desc: "Introduction to Artificial Intelligence through fun tools, voice commands, and simple logic games."
        },
        {
          title: "Mini Film Maker",
          desc: "Kids create short videos by learning storytelling, basic shooting, and acting."
        },
        {
          title: "Science Magic",
          desc: "Exciting hands-on experiments that make children fall in love with science."
        },
        {
          title: "Creative Building",
          desc: "Imagination-focused activities using blocks and DIY projects to improve problem-solving."
        },
        {
          title: "Dance & Rhythm",
          desc: "Energetic dance sessions to improve coordination and stage confidence."
        },
        {
          title: "Swimming",
          desc: "Water confidence training and safety techniques under supervision."
        },
        {
          title: "Assisted Pony Riding",
          desc: "Safe and guided introduction to horse riding to build courage and balance."
        },
        {
          title: "Yoga",
          desc: "Simple yoga practices to improve focus, flexibility, and calmness."
        }
      ],
      highschool: [
        {
          title: "AI & Coding",
          desc: "Students learn basics of Artificial Intelligence and logic building through interactive tools."
        },
        {
          title: "DJ Mixing",
          desc: "Hands-on experience with professional DJ equipment — learning beats and live performance."
        },
        {
          title: "Film Making",
          desc: "Complete exposure to scripting, shooting, and editing to create short films."
        },
        {
          title: "Horse Riding",
          desc: "Professional training focusing on control, posture, and confidence building."
        },
        {
          title: "Swimming",
          desc: "Structured sessions to improve technique, stamina, and water safety."
        },
        {
          title: "Kalari Training",
          desc: "Ancient Indian martial art training for discipline, strength, and focus."
        },
        {
          title: "Gada Training",
          desc: "Traditional strength training to improve power and endurance."
        },
        {
          title: "Dance & Fitness",
          desc: "Combination routines to boost energy, body control, and confidence."
        },
        {
          title: "Drone Flying",
          desc: "Introduction to drone technology with practical flying sessions."
        }
      ]
    },
    dailySchedule: {
      days: "Monday to Friday: 9:00 AM – 3:00 PM | Sat: Half Day",
      includes: [
        "Skill Sessions",
        "Physical Activities",
        "Breaks & Refreshments",
        "Practice & Performance Time"
      ]
    },
    specialHighlights: [
      "Real Horse Riding Experience 🐎",
      "Live DJ Setup Training 🎧",
      "AI & Future Tech Exposure 🤖",
      "Indian Martial Arts (Kalari & Gada) ⚔️",
      "Drone Flying Introduction 🚁"
    ],
    whyChoose: [
      "10+ Skill Categories in One Camp",
      "Professional Trainers & Coaches",
      "Safe & Structured Environment",
      "Focus on Confidence & Personality",
      "Fun + Learning Combination"
    ],
    learningOutcomes: [
      "Confidence in public speaking & performance",
      "Exposure to modern technology & creative fields",
      "Physical strength and discipline",
      "Teamwork and social skills",
      "Clarity on interests and future skills"
    ],
    brochures: ["./images/IRIS01.jpeg", "./images/IRIS02.jpeg"],
    contact: "98498 56143"
  },



  {
    id: "tech-gen-meridian",
    title: "Tech Generation Summer Camp 2026 (Meridian School, Uppal)",
    subtitle: "STEM • Life Skills • Arts • Adventure",
    ageGroup: "4–15 Years",
    venue: "Meridian School, Uppal, Hyderabad",
    dates: "1st May – 31st May 2026",
    fee: "Contact Venue",
    timings: "9:00 AM – 3:00 PM",
    image: "./images/MeridianUPAL01.jpeg",
    aboutProgram: "Tech Generation Summer Camp is a unique skill-based learning experience designed to help children explore technology, creativity, fitness, and life skills — all in one place.",
    trainingModel: {
      title: "Hybrid Experiential Learning Model",
      steps: [
        "Learn → Practice → Perform: Students first understand concepts, then practice hands-on, and finally present what they've learned.",
        "Multi-Skill Rotation System: Balanced development between Technology, Arts, and Physical Activities.",
        "Level-Based Training: Separate fun-based learning for primary and skill-focused training for high school.",
        "Weekly Progress Tracking: Continuous observation and confidence-building activities.",
        "Final Showcase & Recognition: Participation in DJ performances, talent shows, and film screenings."
      ]
    },
    activities: {
      primary: [
        {
          title: "AI & Coding",
          desc: "Students are introduced to the world of Artificial Intelligence and programming, where they learn logic building, problem-solving, and how modern technology works through interactive projects."
        },
        {
          title: "Horse Riding",
          desc: "A unique hands-on experience that teaches balance, courage, and control. Students learn basic riding techniques under expert supervision in a safe environment."
        },
        {
          title: "DJ Mixing",
          desc: "Students explore music creation using professional DJ equipment, learning beat matching, transitions, and live performance skills."
        },
        {
          title: "Film Making",
          desc: "From idea to screen — students learn storytelling, shooting, and editing, creating their own short films and creative content."
        },
        {
          title: "Machine Learning Basics",
          desc: "An introduction to how machines think and learn. Students explore real-world AI applications in a simplified and engaging way."
        },
        {
          title: "Kalari Training",
          desc: "Ancient Indian martial art that builds discipline, flexibility, strength, and focus while connecting students to traditional practices."
        },
        {
          title: "Gada Training",
          desc: "A traditional strength-training method inspired by Indian warriors that improves power, endurance, and physical fitness."
        },
        {
          title: "Yoga & Mindfulness",
          desc: "Daily sessions to improve focus, emotional balance, flexibility, and inner calm, helping students stay relaxed and confident."
        },
        {
          title: "Adventure Challenges",
          desc: "Fun obstacle-based activities that develop teamwork, confidence, leadership, and problem-solving skills."
        }
      ],
      highschool: [
        {
          title: "AI & Coding",
          desc: "Students are introduced to the world of Artificial Intelligence and programming, where they learn logic building, problem-solving, and how modern technology works through interactive projects."
        },
        {
          title: "Horse Riding",
          desc: "A unique hands-on experience that teaches balance, courage, and control. Students learn basic riding techniques under expert supervision in a safe environment."
        },
        {
          title: "DJ Mixing",
          desc: "Students explore music creation using professional DJ equipment, learning beat matching, transitions, and live performance skills."
        },
        {
          title: "Film Making",
          desc: "From idea to screen — students learn storytelling, shooting, and editing, creating their own short films and creative content."
        },
        {
          title: "Machine Learning Basics",
          desc: "An introduction to how machines think and learn. Students explore real-world AI applications in a simplified and engaging way."
        },
        {
          title: "Kalari Training",
          desc: "Ancient Indian martial art that builds discipline, flexibility, strength, and focus while connecting students to traditional practices."
        },
        {
          title: "Gada Training",
          desc: "A traditional strength-training method inspired by Indian warriors that improves power, endurance, and physical fitness."
        },
        {
          title: "Yoga & Mindfulness",
          desc: "Daily sessions to improve focus, emotional balance, flexibility, and inner calm, helping students stay relaxed and confident."
        },
        {
          title: "Adventure Challenges",
          desc: "Fun obstacle-based activities that develop teamwork, confidence, leadership, and problem-solving skills."
        }
      ]
    },
    dailySchedule: {
      days: "Monday to Friday: 9:00 AM – 3:00 PM | Sat: Half Day",
      includes: [
        "Skill Sessions",
        "Physical Activities",
        "Breaks & Refreshments",
        "Practice & Performance Time"
      ]
    },
    specialHighlights: [
      "Real Horse Riding Experience 🐎",
      "Live DJ Setup Training 🎧",
      "AI & Future Tech Exposure 🤖",
      "Indian Martial Arts (Kalari & Gada) ⚔️",
      "Adventure Challenges 🧗"
    ],
    whyChoose: [
      "Combination of Technology + Fitness + Creativity",
      "Real-world exposure instead of classroom-only learning",
      "Focus on confidence, discipline, and personality development",
      "Balanced schedule for both mental and physical growth"
    ],
    learningOutcomes: [
      "Confidence in public speaking & performance",
      "Exposure to modern technology & creative fields",
      "Physical strength and discipline",
      "Teamwork and social skills",
      "Clarity on interests and future skills"
    ],
    brochures: ["./images/MeridianUPAL01.jpeg", "./images/MeridianUPAL02.jpeg"],
    contact: "98498 56143"
  },
  {
    id: "tech-gen-iris-kphb",
    title: "Tech Generation Summer Camp 2026 (Iris Florets, KPHB)",
    subtitle: "From AI to Kalari... One Camp. Unlimited Skills!",
    ageGroup: "4–15 Years",
    venue: "Iris Florets, KPHB Phase-5, Hyderabad",
    dates: "April 27th to May 27th, 2026",
    fee: "₹6,500/-",
    timings: "9:00 AM to 3:00 PM",
    image: "./images/IRIS-Florets-KPHB01.JPEG",
    aboutProgram: "Tech Generation Summer Camp at Iris Florets, KPHB is a unique skill-based learning experience designed to help children explore technology, creativity, fitness, and life skills — all in one place. We follow a Hybrid Experiential Learning Model: Learn → Practice → Perform.",
    trainingModel: {
      title: "Hybrid Experiential Learning Model",
      steps: [
        "Learn → Practice → Perform: Students first understand concepts, then practice hands-on, and finally present what they've learned.",
        "Multi-Skill Rotation System: Balanced development between Technology, Arts, and Physical Activities.",
        "Outcome-Oriented Training: Focus on building confidence, creativity, and real-world skills."
      ]
    },
    activities: {
      primary: [
        {
          title: "Junior AI & Tech Lab",
          desc: "Children are introduced to the world of Artificial Intelligence through fun tools, voice-based activities, and simple logic building exercises."
        },
        {
          title: "Mini Film Maker Studio",
          desc: "Kids learn storytelling, acting, and basic video creation by making their own short films — improving creativity and confidence."
        },
        {
          title: "Science Magic Lab",
          desc: "Exciting experiments and “magic-style” science activities that make learning fun and help children understand basic scientific concepts."
        },
        {
          title: "Adventure & Action Zone",
          desc: "Engaging physical activities designed to build courage, coordination, and active participation."
        },
        {
          title: "Creative Building",
          desc: "Hands-on activities using blocks, models, and DIY kits to improve imagination, creativity, and problem-solving skills."
        },
        {
          title: "Innovation Lab",
          desc: "Encourages kids to think differently by creating simple ideas, models, and fun innovations."
        },
        {
          title: "Stage Speaking",
          desc: "Basic public speaking sessions to help children overcome stage fear and express themselves confidently."
        },
        {
          title: "Money Smart Kids Program",
          desc: "Introduction to basic money concepts like saving, spending, and smart thinking through fun activities."
        },
        {
          title: "Dance & Rhythm Studio",
          desc: "Energetic dance sessions to improve body movement, rhythm, and self-expression."
        },
        {
          title: "Jr AI Music Composer",
          desc: "Kids explore music creation using simple AI tools and digital platforms."
        }
      ],
      highschool: [
        {
          title: "AI & Coding",
          desc: "Students learn the fundamentals of Artificial Intelligence, logic building, and coding through real-world applications."
        },
        {
          title: "Machine Learning",
          desc: "Introduction to how machines learn and make decisions using simple practical examples and tools."
        },
        {
          title: "Advanced Film Making",
          desc: "Students learn scripting, shooting, and editing techniques to create professional-level short films."
        },
        {
          title: "Cinematography Studio",
          desc: "Hands-on training in camera angles, lighting, and visual storytelling."
        },
        {
          title: "DJ Mixing",
          desc: "Practical experience with DJ equipment — learning beats, transitions, and live performance skills."
        },
        {
          title: "Music Production Studio",
          desc: "Students learn how to create and mix music digitally using professional tools."
        },
        {
          title: "Kalari & Gada Training",
          desc: "Traditional Indian martial arts training that builds discipline, strength, flexibility, and mental focus."
        },
        {
          title: "Drone Technology",
          desc: "Introduction to drone operations and hands-on flying sessions."
        },
        {
          title: "Entrepreneurship Sessions",
          desc: "Students learn basic business ideas, startup thinking, and how to turn ideas into opportunities."
        },
        {
          title: "Salsa & Contemporary Dance",
          desc: "Professional dance training to improve flexibility, expression, and stage confidence."
        }
      ]
    },
    dailySchedule: {
      days: "April 27th to May 27th | 9:00 AM to 3:00 PM",
      includes: [
        "Core Skill Sessions (AI, Film Making, Coding)",
        "Physical Training (Kalari, Dance, Adventure Zone)",
        "Creative Labs (Innovation, Music, Science)",
        "Lunch & Refreshment Breaks"
      ]
    },
    specialHighlights: [
      "Drone Flying Experience 🚁",
      "Short Film Shooting 🎬",
      "Startup & Money Management Learning 💰",
      "Electronic Music & DJ Mixing 🎧",
      "Traditional Martial Arts (Kalari & Gada) ⚔️"
    ],
    whyChoose: [
      "Future-Ready Curriculum (AI, ML, Drones)",
      "Balanced Mind-Body-Creativity Development",
      "Professional Industry Coaches",
      "Hands-on Project-Based Learning",
      "Confidence & Personality Building"
    ],
    learningOutcomes: [
      "Confidence in speaking & performing",
      "Exposure to future technologies (AI, ML, Drone)",
      "Creativity through film, music & arts",
      "Physical strength & discipline",
      "Real-world skill awareness"
    ],
    brochures: ["./images/IRIS-Florets-KPHB01.JPEG", "./images/IRIS-Florets-KPHB02.JPEG"],
    contact: "98498 56143 | 99495 67143"
  },
  {
    id: "tech-gen-meridian-kompally",
    title: "Tech Generation Summer Camp 2026 (Meridian School, Kompally)",
    subtitle: "STEM • Life Skills • Arts • Adventure",
    ageGroup: "4–15 Years",
    venue: "Meridian School, Kompally, Hyderabad",
    dates: "May 1st to May 31st, 2026",
    fee: "See Brochure",
    timings: "9:00 AM – 3:00 PM",
    image: "./images/Meridian-Kompally-01.JPEG",
    aboutProgram: "Not just summer fun… We focus on building skills, confidence, and real-world exposure that stay with children for life. Our camp combines Technology + Creativity, Physical Strength + Discipline, and Fun + Learning for a perfect balance for overall child development.",
    trainingModel: {
      title: "Balanced Development Model",
      steps: [
        "Technology + Creativity: Merging digital skills with artistic expression.",
        "Physical Strength + Discipline: Building a strong body and focused mind.",
        "Experiential Learning: Hands-on sessions followed by performance and showcase."
      ]
    },
    activities: {
      primary: [
        {
          title: "Junior AI Lab",
          desc: "Kids explore the basics of Artificial Intelligence through fun tools, interactive games, and voice-based learning."
        },
        {
          title: "Mini Film Maker",
          desc: "Children learn storytelling, acting, and video creation by making their own short films."
        },
        {
          title: "Science Magic",
          desc: "Fun experiments that make science exciting and easy to understand."
        },
        {
          title: "Creative Building",
          desc: "Hands-on activities that improve imagination, creativity, and problem-solving skills."
        },
        {
          title: "Dance & Rhythm",
          desc: "Energetic dance sessions to build coordination, rhythm, and confidence."
        },
        {
          title: "Swimming",
          desc: "Basic swimming training with safety guidance to improve fitness and water confidence."
        },
        {
          title: "Assisted Pony Riding",
          desc: "Safe introduction to horse riding to build courage, balance, and excitement."
        },
        {
          title: "Yoga",
          desc: "Simple yoga practices to improve focus, flexibility, and calmness."
        }
      ],
      highschool: [
        {
          title: "AI & Coding",
          desc: "Students learn logic building, coding basics, and real-world applications of Artificial Intelligence."
        },
        {
          title: "DJ Mixing",
          desc: "Hands-on training with DJ equipment — learning beats, transitions, and live performance."
        },
        {
          title: "Film Making",
          desc: "Complete exposure to scripting, shooting, and editing short films."
        },
        {
          title: "Horse Riding",
          desc: "Professional riding training to improve balance, confidence, and control."
        },
        {
          title: "Swimming",
          desc: "Structured sessions to improve technique, stamina, and water safety."
        },
        {
          title: "Kalari Training",
          desc: "Ancient Indian martial art that builds discipline, flexibility, and mental focus."
        },
        {
          title: "Gada Training",
          desc: "Traditional strength training to improve physical power and endurance."
        },
        {
          title: "Dance & Fitness",
          desc: "High-energy sessions combining dance and fitness for better stamina and confidence."
        }
      ]
    },
    dailySchedule: {
      days: "May 1st – May 31st | 9:00 AM – 3:00 PM",
      includes: [
        "Tech & Skills Workshops (AI, Film, DJ)",
        "Fitness & Adventure (Swimming, Martial Arts, Horse Riding)",
        "Creative Labs & Practice Time",
        "Performances & Weekly Highlights"
      ]
    },
    specialHighlights: [
      "Drone Flying Experience 🚁",
      "Short Film Creation 🎬",
      "DJ Practice & Performance 🎧",
      "Horse Riding Sessions 🐎",
      "Kalari & Gada Training ⚔️",
      "Talent Show & Closing Ceremony 🎓"
    ],
    whyChoose: [
      "10+ Skills Categorized into Tech & Fitness",
      "Expert Coaches & Mentors",
      "Focus on Life Skills & Personality",
      "Real-world Projects (Film, Music, Coding)",
      "Safe and Secure School Environment"
    ],
    learningOutcomes: [
      "Confidence in speaking & performing",
      "Exposure to AI, coding & future skills",
      "Creativity through film & music",
      "Physical strength & discipline",
      "Teamwork and social skills"
    ],
    brochures: ["./images/Meridian-Kompally-01.JPEG", "./images/Meridian-Kompally-02.JPEG"],
    contact: "98498 56143"
  }
];
